import React from 'react';
import PropTypes from 'prop-types';
//
// material-ui
import Grid from '@mui/material/Grid';

function BreweryLogo({ logoUrl }) {
  if (!logoUrl) {
    logoUrl =
      'https://firebasestorage.googleapis.com/v0/b/id-tap-that-backend.appspot.com/o/app_icon50.png?alt=media&token=2c784a42-a970-42e2-98ed-d3c8645ecd6f';
  }
  return (
    <Grid container spacing={2} sx={{
      padding: 2
    }}>
      <Grid item xs={12} style={{ display: 'flex' }} sx={{
        alignItems: "start"
      }}>
        <img src={logoUrl} alt={'logo'} width="200" />
      </Grid>
    </Grid>
  );
}

BreweryLogo.propTypes = {
  logoUrl: PropTypes.string,
};

export default BreweryLogo;
